import * as React from 'react';
import {Asset, Datapoint} from '@deviceinsight/ng-ui-api-client';
import {fetchDatapointsByAssetId} from '@deviceinsight/ng-ui-api-client';
import DatapointSelectionTable from './table/DatapointSelectionTable';
import {DEFAULT_SELECTABLE_DATATYPES} from './columnDefs/datapoints';
type Props = {
	asset: Asset;
	onDatapointSelect: (arg0: Datapoint) => void;
	availableDataTypes?: Array<string>;
};
type State = {
	datapoints: Array<Datapoint>;
	loading: boolean;
};
export default class DatapointSearchComponent extends React.Component<Props, State> {
	state = {
		datapoints: [],
		loading: false
	};

	getDataTypes() {
		const {availableDataTypes} = this.props;
		return availableDataTypes ? availableDataTypes : DEFAULT_SELECTABLE_DATATYPES;
	}

	componentDidMount() {
		const {
			asset: {id}
		} = this.props;
		const availableDataTypes = this.getDataTypes();
		fetchDatapointsByAssetId(id).then((results) => {
			this.setState({
				datapoints: results.filter((each) => availableDataTypes.includes(each.datatype))
			});
		});
	}

	render() {
		const {datapoints, loading} = this.state;
		const {onDatapointSelect} = this.props;
		return (
			<div>
				<DatapointSelectionTable
					datapoints={datapoints}
					isFetchingDatapoints={loading}
					onSelectDatapoint={(datapoint) => onDatapointSelect(datapoint)}
					availableDataTypes={this.getDataTypes()}
				/>
			</div>
		);
	}
}
